import { getConsent } from "./consent";

// Launch only after destination, currency, measurement and visual QA are verified.
export const HOMEPAGE_EXPERIMENT = Object.freeze({
  id: "homepage-202609-v1", enabled: false,
  variants: ["control-long", "priced-long", "compact", "priced-compact", "optin-only", "ebook"],
  activeVariants: ["control-long", "priced-long"],
});
const KEY = "btk_homepage_assignment_v1";
const TTL = 30 * 86400000;
let current = null;
export const chooseVariant = (value, variants = HOMEPAGE_EXPERIMENT.activeVariants) => variants[Math.min(variants.length - 1, Math.max(0, Math.floor(value * variants.length)))];
const valid = (a, now) => a && a.experiment_id === HOMEPAGE_EXPERIMENT.id && HOMEPAGE_EXPERIMENT.activeVariants.includes(a.variant_id) && /^[a-f0-9-]{36}$/.test(a.assignment_id || "") && Number.isFinite(a.created_at) && now >= a.created_at && now - a.created_at < TTL;
export function getHomepageAssignment() {
  if (typeof window === "undefined") return null;
  const preview = new URLSearchParams(window.location.search).get("btk_variant");
  if (HOMEPAGE_EXPERIMENT.variants.includes(preview)) return { variant_id: preview, preview: true };
  if (!HOMEPAGE_EXPERIMENT.enabled) return null;
  const now = Date.now();
  if (!valid(current, now)) {
    if (getConsent() === "granted") {
      try { const saved = JSON.parse(window.localStorage.getItem(KEY)); if (valid(saved, now)) current = saved; } catch { /* unavailable storage */ }
    }
    if (!valid(current, now)) {
      if (!window.crypto?.randomUUID || !window.crypto?.getRandomValues) return null;
      const sample = window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296;
      current = { experiment_id: HOMEPAGE_EXPERIMENT.id, variant_id: chooseVariant(sample), assignment_id: window.crypto.randomUUID(), created_at: now };
    }
  }
  if (getConsent() === "granted") {
    try { window.localStorage.setItem(KEY, JSON.stringify(current)); } catch { /* memory preserves this page session */ }
  }
  return current;
}
export function experimentProperties() {
  const a = getHomepageAssignment();
  return a && !a.preview ? { experiment_id: a.experiment_id, variant_id: a.variant_id, assignment_id: a.assignment_id } : {};
}
